import React from "react";
import {
    StepContent,
    StepContainer,
    AspectRatioBox,
    StepFooter,
    StepFooterText,
    CheckIcon,
    StepFooterDescription,
    UploadButtonWrapper,
    HiddenFileInput,
    UploadLabel,
} from "../survey.styled";

interface FirstStepProps {
    onVideoUpload: (file: File) => void;
    onFileSizeError: () => void;
}

const FirstStep: React.FC<FirstStepProps> = ({ onVideoUpload, onFileSizeError }) => {
    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;
        const limitMb = (window as any).pgChat?.fileSizeLimit ?? 250;
        if (file.size > limitMb * 1024 * 1024) {
            e.target.value = '';
            onFileSizeError();
            return;
        }
        onVideoUpload(file);
    };

    return (
        <StepContent>
            <StepContainer>
                <AspectRatioBox>
                    <iframe
                        width="560"
                        height="315"
                        src="https://player.vimeo.com/video/892697319?color=FD3300"
                        frameBorder="0"
                        allow="autoplay; encrypted-media"
                        allowFullScreen
                        title="VIP Coaching - How to record your swing"
                    />
                </AspectRatioBox>
                <StepFooter>
                    <StepFooterText>
                        <CheckIcon />
                        <StepFooterDescription>
                            Watch the video for important instructions about how to upload a video of your swing for your coach to review
                        </StepFooterDescription>
                    </StepFooterText>
                    <UploadButtonWrapper>
                        <HiddenFileInput
                            type="file"
                            name="vip-video"
                            id="onboarding-video"
                            accept="video/mp4,video/x-m4v,video/*"
                            onChange={handleFileChange}
                        />
                        <UploadLabel htmlFor="onboarding-video">
                            Upload Swing Video
                        </UploadLabel>
                    </UploadButtonWrapper>
                </StepFooter>
            </StepContainer>
        </StepContent>
    );
};

export default FirstStep;